import React from "react";
import { createGlobalStyle } from "styled-components";

export default function Themes() {
  const colorCodes = JSON.parse(process.env.REACT_APP_MY_COLOR_CODE);
  const GlobalStylesVizerto = createGlobalStyle`
:root {
  --light_color_shade:${colorCodes["light_color_shade"]};
  --dark_color_shade:${colorCodes["dark_color_shade"]};
  --questionText_color:${colorCodes["questionText_color"]};
  --faint_color_shade:${colorCodes["faint_color_shade"]};
  --lighter_color_shade:${colorCodes["lighter_color_shade"]};
  --medium_color_shade:${colorCodes["medium_color_shade"]};
  --darker_color_shade:${colorCodes["darker_color_shade"]};
  --viz_dark_v1_color:#1F93D2;
  --viz_dark_v2_color:#EF7928;
  --viz_light_color:#35BFF0;
  --viz_white_color:#FFFFFF;
  --viz_secondary_dark_color:#808080;
  --viz_secondary_light_color:#D2D2D2;
  --viz_primary_button_color:#1F93D2;
  --viz_secondary_button_color:#075491;
  --viz_tertiary_button_color:#FFFFFF;
  --viz_disabled_button_color:#808080;
}
`;
  return (
    <>
      <GlobalStylesVizerto />
    </>
  );
}
